var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Button,{key:_vm.button.id,attrs:{"to":_vm.button.to,"href":_vm.button.href,"target":_vm.button.target,"variant":_vm.button.variant,"disabled":_vm.button.disabled,"icon-before":_vm.button.iconBefore,"icon-after":_vm.button.iconAfter,"spacing":"loose"}},[_vm._v("\n  "+_vm._s(_vm.button.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }